import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import LandingSection from '../components/LandingSection';
import Logo from '../components/Logo';
import { Toaster } from 'sonner';

const About = () => (
  <div style={{ backgroundColor: '#FFF8F0' }}>
    {/* Minimal sticky header */}
    <motion.header
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: 'easeOut' }}
      className="sticky top-0 z-50 px-6 py-4 flex items-center justify-between"
      style={{
        backgroundColor: 'rgba(255,248,240,0.95)',
        backdropFilter: 'blur(8px)',
        borderBottom: '1px solid rgba(44,36,23,0.08)',
      }}
    >
      <Link to="/" data-testid="about-logo-home">
        <Logo size="small" />
      </Link>
      <Link
        to="/"
        className="px-5 py-2 rounded-full text-sm font-medium text-white transition-opacity hover:opacity-90"
        style={{ background: '#ff780a' }}
        data-testid="about-open-app-btn"
      >
        Open app →
      </Link>
    </motion.header>

    <LandingSection />

    <Toaster
      position="top-center"
      toastOptions={{
        style: { background: '#FFF8F0', border: '1px solid rgba(255, 120, 10, 0.2)', color: '#2C2417' },
      }}
    />
  </div>
);

export default About;
